import { OfferPageActions, type OfferPageDispatchAction, type OfferPageState, type OfferPageRoom } from './offerPageStateReducer'
import { isFlashHotelOffer } from 'lib/offer/offerTypes'
import { getInitialFlashSameRoomSelection } from 'lib/offer/initialSameRoomSelection'

export type OfferPageRoomsTransitionState = Pick<OfferPageState, 'offer' | 'rooms' | 'duration' | 'multiRoomMode' | 'flashPackageSelectionActive' | 'flashSameRoomSelection'>

/** Build the shared action for applying a quantity draft from desktop and mobile occupancy pickers. */
export function applyFlashQuantityDraft(draft: OfferPageState['flashQuantityDraft']): Extract<OfferPageDispatchAction, { type: OfferPageActions.toggleMultiRoomMode }> | undefined {
  if (!draft || !draft.rooms.length) return undefined
  const multiRoomMode = draft.multiRoomMode ?? 'same-room'
  return {
    type: OfferPageActions.toggleMultiRoomMode,
    multiRoomMode,
    rooms: draft.rooms,
    flashSameRoomSelection: multiRoomMode === 'same-room' && draft.rooms.length > 1 ? draft.selection : undefined,
  }
}

/** Decide the Flash selection/count transition before the reducer stores the resulting payload. */
export function setOfferPageRooms(state: OfferPageRoomsTransitionState, requestedRooms: Array<OfferPageRoom>): Extract<OfferPageDispatchAction, { type: OfferPageActions.setRooms }> {
  const offer = state.offer
  if (!state.flashPackageSelectionActive || !isFlashHotelOffer(offer) || state.multiRoomMode !== 'same-room') {
    return { type: OfferPageActions.setRooms, rooms: requestedRooms }
  }
  let rooms = requestedRooms
  let selection = state.flashSameRoomSelection
  if (rooms.length === 1) {
    if (state.rooms.length > 1 && selection?.offerId === offer.id) {
      const pkg = offer.packages.find(candidate => candidate.uniqueKey === selection?.packageKey)
      rooms = rooms.map(room => ({ ...room, roomId: pkg?.id, rateId: pkg?.roomRate.id, optionalBundleIds: undefined }))
    }
    selection = undefined
  } else if (state.rooms.length === 1) {
    selection = getInitialFlashSameRoomSelection(offer, rooms.slice(0, 1), state.duration, 'same-room')
  }
  return { type: OfferPageActions.setRooms, rooms, flashSameRoomSelection: selection }
}
